module.exports = __webpack_public_path__ + "504cc25844b74c241bf631a9cae1634e.svg";